/**
 * Adzuki. My Settings - Franchise Documents list actions
 *
 * SET-69, decision B3: the delete on the Franchise Documents list is a POST.
 *
 * IT WAS A GET LINK with a data-confirm-message in front of it, so the confirmation dialog was
 * the only thing between a link prefetcher and a deletion - and the server re-asked none of it.
 *
 * SET-133 MOVED THE MACHINERY OUT. This was the third copy of it, which is what triggered the
 * extraction; the ajax, the three answers a list endpoint can give and the delegated binding now
 * live in my_settings_list_actions.js.
 *
 * NOTHING HERE WRITES ADVISOR-FACING COPY apart from the last-resort failure string below.
 * Success and refusal text comes from the response, and the delete confirmation is raised BY THE
 * SERVER - franchiseDocumentDelete() answers an unconfirmed request with a confirmation_prompt
 * rather than deleting, so a request that skips the dialog is asked rather than obeyed. The
 * unreviewed-document refusal arrives the same way, as an ordinary error.
 *
 * THE DOWNLOAD IS NOT HERE AND DOES NOT NEED TO BE. It is an ordinary link carrying target, which
 * my_settings.js leaves alone - A3/S5 keeps it a new browser tab rather than modal content.
 */

(function MySettingsDocuments($, Adzuki)
{
	"use strict";

	// INSIDE ready, NOT AT LOAD - see the note in my_settings_shipping.js.
	$(document).ready(function documentReady() {
		if (!Adzuki.MySettings || !Adzuki.MySettings.ListActions) {
			return;
		}

		Adzuki.MySettings.ListActions.bind({
			url    : '/MySettings/franchiseDocuments',
			actions: [
				{
					event   : 'click',
					selector: '[data-my-settings-document-delete]',
					url     : function remove($control) {
						return '/MySettings/franchiseDocumentDelete/' + $control.attr('data-my-settings-document-delete');
					},
					failure: 'There was an error attempting to delete the franchise document.'
				}
			]
		});
	});
}(jQuery, window.Adzuki || {}));
